import Header from "app/ui/Header";
import MenuButton from "app/ui/MenuButton";
import cn from "app/utils/classnames";

interface PauseOverlayProps {
  onResumeClick: () => void;
}

export default function PauseOverlay(props: PauseOverlayProps) {
  return (
    <div
      className={cn(
        "fixed",
        "top-0 bottom-0 left-0 right-0",
        "bg-black/25",
        "flex flex-col justify-center items-center"
      )}
    >
      <div
        className={cn(
          "shrink",
          "max-w-80",
          "px-10 py-9",
          "bg-background",
          "border border-black",
          "flex flex-col justify-evenly items-center gap-8"
        )}
      >
        <Header>Game Paused</Header>
        <p className={cn("text-center")}>
            Click resume when ready to continue.
        </p>
        <MenuButton className={cn("w-30")} onClick={props.onResumeClick}>Resume</MenuButton>
      </div>
    </div>
  );
}
